import Vue from 'vue'
import Vuex from 'vuex'
import vux from './modules/vux.js'
// import page from './modules/page.js'
// import paper from './modules/paper.js'
// import enroll from './modules/enroll.js'
import news from './modules/news.js'
import user from './modules/user.js'

Vue.use(Vuex)
const myPlugin = store => {
  // 当 store 初始化后调用
  store.subscribe((mutation, { user }) => {
    // if (mutation.type === 'updateUserInfo') {
    // }
    // 每次 mutation 之后调用
    // mutation 的格式为 { type, payload }
  })
}

const categoryAppid = localStorage.getItem('categoryAppid')
const categoryList = localStorage.getItem('categoryList')
const titles = localStorage.getItem('titles')

const store = new Vuex.Store({
  modules: {
    vux,
    // page,
    // paper,
    // enroll,
    news,
    user
  },
  state: {
    categoryAppid: categoryAppid||159,
    categoryList: categoryList ? JSON.parse(categoryList) : [],
    baseUrl: 'http://47.104.89.171/pqcms/',
    titles: titles ? JSON.parse(titles) : {}
  },
  getters: {
    getCategoryAppid: state => {
      return state.categoryAppid
    }
  },
  mutations: {
    setCategory (state, payload) {
      state.categoryAppid = payload.id
      localStorage.setItem('categoryAppid', payload.id)
    },
    setCategoryList (state, payload) {
      state.categoryList = payload
      localStorage.setItem('categoryList', JSON.stringify(payload))
    },
    setTitles (state, payload) {
      state.titles = payload
      localStorage.setItem('titles', JSON.stringify(payload))
    }
  },
  // getters: {
  //   urlParams: state => {
  //     return state.route.params
  //   },
  //   pageData: state => {
  //     return state.page.pages[state.route.path]
  //   },
  //   XYZT: state => {
  //     const remaped = function (arr) {
  //       const dic = {}
  //       for (var i = 0; i < arr.length; i++) {
  //         var item = arr[i]
  //         dic[item.name] = item.title
  //       }
  //       return dic
  //     }
  //     return remaped(state.enroll.dic.XYZT1 || [])
  //   },
  //   getDicTreeMaped: (state, getters) => {
  //     const tree = state.enroll.dicTree
  //     if (tree) {
  //       const dic = {}
  //       for (let i = 0; i < tree.length; i++) {
  //         let parent = tree[i]
  //         dic[parent.name] = parent.title
  //         for (let j = 0; j < parent.children.length; j++) {
  //           let children = parent.children[j]
  //           dic[children.name] = children.title
  //         }
  //       }
  //       return dic
  //     } else {
  //       return undefined
  //     }
  //   }
  // },
  plugins: [myPlugin]
})

export default store
